<template>
    <div class="clickable font--s14 font--w700 accentButton flex flex--center color noDec"
         :class="{
             'accentButton--filled': filled,
             'width--100': fullWidth,
             'accentButton--danger': danger,
             'accentButton--disabled': disable,
         }"
         @click="handleClick"
         @keyup.enter="handleClick">
        <transition name="fade" mode="out-in">
            <div v-if="!this.loading" key="title">
                {{ title }}
            </div>
            <div v-else class="absolutes" key="loader">
                <loader :loading="true" color="#E8228F" :size="'10px'"/>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        name: 'AccentButton',
        props: ['title', 'filled', 'fullWidth', 'danger', 'disable', 'loading'],
        methods: {
            handleClick(e) {
                if (!this.disabled) {
                    this.$emit('onClick', e)
                }
            },
        }
    };
</script>


